/**
 * The desktop rail collapsed to icons, remembered per device. `nav-collapsed` on <html> does it in CSS, and only
 * where MQ.collapsibleNav matches, so a choice made on a desktop never touches the iPad's rail.
 */
const KEY = 'taretto.navCollapsed';

export function readNavCollapsed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Sets the class (before React renders, from main.tsx, so the page never flashes the other width) and the key. */
export function applyNavCollapsed(collapsed: boolean) {
  document.documentElement.classList.toggle('nav-collapsed', collapsed);
  try {
    if (collapsed) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable (private mode): collapsed for this visit only */
  }
}
